// Regulations.jsx
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Regulations = () => {
  const [select, setSelect] = useState(0);
  const [searchInput, setSearchInput] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  const regulationsList = [
    { name: '(사)충남산학융합원 정관', pdf: '(사)충남산학융합원 정관 (2023.11.21.개정).pdf' },
    { name: '제 규정 관리 규정', pdf: '1. 제 규정 관리 규정.pdf' },
    { name: '직제 규정', pdf: '2. 직제 규정.pdf' },
    { name: '원장추천위원회 규정', pdf: '3. 원장추천위원회 규정.pdf' },
    { name: '인사 규정', pdf: '4. 인사 규정.pdf' },
    { name: '보수 규정', pdf: '5. 보수 규정.pdf' },
    { name: '회계 규정', pdf: '6. 회계 규정.pdf' },
    { name: '감사 규정', pdf: '7. 감사 규정.pdf' },
    { name: '직원복무 규정', pdf: '8. 직원복무 규정.pdf' },
    { name: '여비 규정', pdf: '9. 여비 규정.pdf' },
    { name: '직인관리 규정', pdf: '10. 직인관리 규정.pdf' },
    { name: '문서관리 규정', pdf: '11. 문서관리 규정.pdf' },
    { name: '운영위원회 규정', pdf: '12. 운영위원회 규정.pdf' },
    { name: '장비구입 및 관리운영 규정', pdf: '13. 장비구입 및 관리운영 규정.pdf' },
    { name: '보안업무 규정', pdf: '14. 보안업무 규정.pdf' },
  ];

  const filteredRegulations = regulationsList.filter((regulation) =>
    regulation.name.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  const handleDownload = (pdfFile) => {
    const filePath = `/files/${pdfFile}`;
    const link = document.createElement('a');
    link.href = filePath;
    link.download = pdfFile;
    link.click();
  };

  const handleSearch = () => {
    setSearchKeyword(searchInput.trim());
  };

  const handleReset = () => {
    setSearchInput('');
    setSearchKeyword('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        {/* 상단 배너 */}
        <div className="sub_banner_area intro-field">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}융합원 소개{' > '}관리규정
            </div>
            <div className="banner_main_text">관리규정</div>
          </div>
        </div>

        {/* 드롭다운 네비게이션 */}
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">융합원소개</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>

            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">관리규정</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/intro')}>
                  인사말
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  비전 및 목표
                </div>
                <div className="select_row" onClick={() => movePage('/history')}>
                  연혁
                </div>
                <div className="select_row" onClick={() => movePage('/organization')}>
                  조직도
                </div>
                <div className="select_row" onClick={() => movePage('/introduce')}>
                  소개자료
                </div>
                <div className="select_row" onClick={() => movePage('/regulations')}>
                  관리규정
                </div>
                <div className="select_row" onClick={() => movePage('/map')}>
                  오시는 길
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메인 */}
        <div className="sub_main_area regulations">
          {/* 왼쪽 고정 사이드 메뉴 */}
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>융합원소개</span>
                <div className="center_line"></div>
              </div>
            </div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/intro')}`} onClick={() => movePage('/intro')}>
                <span>인사말</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/vision')}`} onClick={() => movePage('/vision')}>
                <span>비전 및 목표</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/history')}`} onClick={() => movePage('/history')}>
                <span>연혁</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/organization')}`} onClick={() => movePage('/organization')}>
                <span>조직도</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/introduce')}`} onClick={() => movePage('/introduce')}>
                <span>소개자료</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/regulations')}`} onClick={() => movePage('/regulations')}>
                <span>관리규정</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/map')}`} onClick={() => movePage('/map')}>
                <span>오시는 길</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          {/* 오른쪽 내용 영역 */}
          <div className="sub_main_back regulations">
            <div className="vision_container regulations">
              {/* 타이틀 */}
              <div className="vision_title_box">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">관리규정</div>
              </div>

              {/* 상단 검색/카운트 영역 */}
              <div className="regulations-search-wrap">
                <div className="regulations-count">
                  총 <span className="regulations-all">{filteredRegulations.length}</span>건
                </div>
                <div className="regulations-search-box">
                  <input
                    type="text"
                    className="regulations-search-input"
                    placeholder="규정명을 입력하세요"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <button type="button" className="regulations-btn btn-search" onClick={handleSearch}>
                    검색
                  </button>
                  <button type="button" className="regulations-btn btn-reset" onClick={handleReset}>
                    초기화
                  </button>
                </div>
              </div>

              {/* 리스트 / 결과 */}
              {filteredRegulations.length === 0 ? (
                <div className="regulations-empty">
                  <div className="regulations-empty-icon">🔍</div>
                  <div className="regulations-empty-title">해당 규정이 존재하지 않습니다.</div>
                  <div className="regulations-empty-desc">
                    검색어를 다시 확인하시거나&nbsp;‘초기화’ 버튼을 눌러 전체 목록을 확인해 주세요.
                  </div>
                </div>
              ) : (
                <>
                  <div className="regulations-list">
                    {filteredRegulations.map((regulation, index) => (
                      <div key={index} className="regulation-card" onClick={() => handleDownload(regulation.pdf)}>
                        <div className="regulation-info">
                          <div className="regulation-title">{regulation.name}</div>
                        </div>
                        <div className="regulation-download-btn">
                          <div className="regulation-download-icon" />
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="right-txss">※ 항목을 클릭하시면 PDF 파일이 다운로드됩니다.</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Regulations;
